import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import logo from "../assets/logo.svg";
import { Toolbar } from "@material-ui/core";
import HeaderStyles from "../themes/HeaderStyles";
import { withStyles } from "@material-ui/core/styles";
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      mobileMoreAnchorEl: null,
      open: null
    };
  }

  handleProfileMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, open: true });
  };

  handleDocumentOpen = () => {
    console.log(window.origin);
    if (window.origin === 'https://fflob.azurewebsites.net') {
      window.open("https://frontlinefunctions.azurewebsites.net/");
    }
    if (window.origin === 'http://localhost:3000') {
      window.open("https://frontlinefunctions.azurewebsites.net/");
    }
    if (window.origin === 'https://freightprod.azurewebsites.net') {
      window.open("https://frontlineprod.azurewebsites.net/");
    }
  }

  handleHelpDocumentOpen = ()=>{
    window.open("https://tmilltd.sharepoint.com/sites/DMSTest/Freight%20Forwarding/Forms/AllItems.aspx?id=%2Fsites%2FDMSTest%2FFreight%20Forwarding%2FFreight%20Forwarding%20Manual%2Epdf&parent=%2Fsites%2FDMSTest%2FFreight%20Forwarding")
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };

  handleMobileMenuOpen = (event) => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };



  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };

  render() {
    const { handleChangeNavDrawer, classes, logout } = this.props;
    const { anchorEl, open } = this.state;
    const isMenuOpen = Boolean(anchorEl);

    const refreshPage = () => {
      window.location.reload();
    }

    return (
      <div>
        <Hidden mdUp>
          <AppBar
            color="white"
            className={classNames(classes.appbar, classes.elevationNone)}
          >
            <Avatar alt="Tmill logo" src={logo} className={classes.small} />
          </AppBar>
        </Hidden>
        <AppBar
          className={classNames(
            classes.appBar,
            {
              [classes.appBarShift]: true,
            },
            classes.elevationNone
          )}
        >
          <Toolbar className="elevationNone justifyContentSB">
              <Avatar alt="Tmill logo" src={logo} className={classes.small} />
              <div className="headerHeading">Track Shipment</div>
              <IconButton
              className={classes.menuButton}
              color="primary"
              // aria-label="Open drawer"
              //onMouseEnter={handleChangeNavDrawer}
              //onMouseLeave={handleChangeNavDrawer}
              onClick={refreshPage}
            >
              <HomeOutlinedIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  styles: PropTypes.object,

  handleChangeNavDrawer: PropTypes.func,

  classes: PropTypes.object,

  navDrawerOpen: PropTypes.bool,

  handleClose: PropTypes.func,
};

export default withStyles(HeaderStyles)(Header);
